export default __webpack_public_path__ + "static/media/modal-bg.812f58bf.jpg";